import { Fragment, useRef, useState } from "react";
import "./App.css";
import FakeLink from "./FakeLink.tsx";
import Footer from "./Footer.tsx";
import Header from "./Header.tsx";
import LinkHoverAnimation from "./LinkHoverAnimation.tsx";
import { ALL_LINKS, LINK_DETAILS, LINK_SECTION } from "./constants.tsx";
import H1 from "./H1.tsx";

export function App() {
  const [activeLinkIdx, setActiveLinkIdx] = useState<number>(NaN);
  const [activeLinkSection, setActiveLinkSection] = useState<LINK_SECTION>(NaN);
  const hoverAnimationPortal = useRef<HTMLDivElement>(null);

  function onProjectTitleHover(linkSection: LINK_SECTION, idx: number) {
    setActiveLinkIdx(idx);
    setActiveLinkSection(linkSection);
  }

  function renderLink(
    linkDetails: LINK_DETAILS,
    isActive: boolean,
    onHover: () => void,
  ) {
    return (
      <Fragment key={linkDetails.id}>
        <FakeLink
          title={linkDetails.title}
          isActive={isActive}
          onHover={onHover}
          isDarkArrow={!!linkDetails?.animate?.theme?.isDarkArrow}
        />
      </Fragment>
    );
  }

  function renderAnimation(
    linkDetails: LINK_DETAILS,
    isActive: boolean,
  ) {
    return (
      <Fragment key={linkDetails.id}>
        <LinkHoverAnimation
          AnimateFromRight={linkDetails?.animate?.fromRight}
          AnimateFromLeft={linkDetails?.animate?.fromLeft}
          isActive={isActive}
          animate={linkDetails?.animate}
        >
        </LinkHoverAnimation>
      </Fragment>
    );
  }

  function renderLinks(linkSection: LINK_SECTION) {
    return ALL_LINKS[linkSection].map((linkDetails, idx) => {
      const isActive = activeLinkSection === linkSection &&
        activeLinkIdx === idx;

      return renderLink(
        linkDetails,
        isActive,
        onProjectTitleHover.bind(null, linkSection, idx),
      );
    });
  }

  function renderAnimations(linkSection: LINK_SECTION) {
    return ALL_LINKS[linkSection].map((linkDetails, idx) => {
      const isActive = activeLinkSection === linkSection &&
        activeLinkIdx === idx;

      return renderAnimation(
        linkDetails,
        isActive,
      );
    });
  }

  return (
    <>
      <div ref={hoverAnimationPortal}></div>
      <Header></Header>
      <main className="flex row">
        <section className="mb-22 mt-32 ml-32 min-w-[60%]">
          <H1>UI-UX Design Projects</H1>
          <ul>{renderLinks(LINK_SECTION.UI_UX_DESIGN_PROJECTS)}</ul>
          <H1 className="mt-22">Frames & Forms</H1>
          <ul>{renderLinks(LINK_SECTION.FRAMES_FORMS)}</ul>
        </section>
        <aside className="grow top-[80px] flex self-start relative">
          {renderAnimations(LINK_SECTION.UI_UX_DESIGN_PROJECTS)}
          {renderAnimations(LINK_SECTION.FRAMES_FORMS)}
        </aside>
      </main>
      <Footer></Footer>
    </>
  );
}
